import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import format from 'xml-formatter';

@Component({
  selector: 'app-sandbox-log-view',
  templateUrl: './sandbox-log-view.component.html',
  styleUrls: ['./sandbox-log-view.component.scss']
})
export class SandboxLogViewComponent implements OnInit {
  constructor(private _aRoute: ActivatedRoute) {}

  public xml: any = '';
  ngOnInit(): void {
    this._aRoute.paramMap.subscribe((params: ParamMap) => {
      let id: any = params.get('id');
      let logData = localStorage.getItem('xml-log-data');
      if (logData != null && logData != 'null' && id != null) {
        const logList = JSON.parse(logData);
        const currentLog = logList.find((obj: any) => obj.key == id);
        if (currentLog) {
          this.xml = format(currentLog.value, {
            indentation: '  ',
            filter: (node) => node.type !== 'Comment',
            collapseContent: true,
            lineSeparator: '\n'
          });
        }
      }
    });
  }
  ngAfterViewChecked(): void {
    localStorage.removeItem('redirect_url');
  }
}
